import notification from './notification.reducer';

export default notification;


// WEBPACK FOOTER //
// src/main/content/notification/store/reducers/index.js